import { Tip } from "../types";

export const tips: Tip[] = [
  {
    tip: "아래와 같은 조합으로 검색을 하시면 더욱 정확한 결과가 검색됩니다.",
  },
  {
    tip: "도로명 + 건물번호",
    subTip: "예) 판교역로 235, 제주 첨단로 242",
  },
  {
    tip: "지역명(동/리) + 번지",
    subTip: "예) 삼평동 681, 제주 영평동 2181",
  },
  {
    tip: "지역명(동/리) + 건물명(아파트명)",
    subTip: "예) 분당 주공, 연수동 주공3차",
  },
  {
    tip: "사서함명 _ 번호",
    subTip: "예) 분당우체국사서함 1~100",
  },
];
